import CancelUpdateProfile from './cancel_update_profile';

export default class CancelUpdatePhoneNumber extends CancelUpdateProfile {}
